<template>
  <InputWrapper
    v-slot="{ inputId }"
    :input-id="id"
    :label="t('orders.origin')"
    class="order-origin-filter"
    optional
  >
    <LocationFilter
      :id="inputId"
      v-model="origin"
      :placeholder="t('orders.origin')"
      append-to="body"
    />
  </InputWrapper>
</template>

<script lang="ts" setup>
import { computed, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { useModelValue } from '@rygen/rygen-ui/composables';

import { LocationFilters, OrderSearchCriteria } from '@/model';

import LocationFilter from '@/components/search/LocationFilter.vue';
import InputWrapper from '@rygen/rygen-ui/components/form/InputWrapper.vue';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  modelValue: {
    type: OrderSearchCriteria,
    default: () => new OrderSearchCriteria(),
  },
});
const { id, modelValue } = toRefs(props);
const emit = defineEmits<{
  (event: 'update:model-value', newVal: OrderSearchCriteria): void;
}>();
const { t } = useI18n();
const { internalValue } = useModelValue(modelValue, {
  emit,
  factoryMethod: (opts: Partial<OrderSearchCriteria>) =>
    new OrderSearchCriteria(opts),
});

const origin = computed({
  get() {
    return new LocationFilters({
      locationId: internalValue.value.originLocationId,
      locationName: internalValue.value.originLocationName,
      locationCode: internalValue.value.originLocationCode,
      city: internalValue.value.originCity,
      state: internalValue.value.originState,
      postalCode: internalValue.value.originPostalCode,
      country: internalValue.value.originCountry,
    });
  },
  set(newVal: LocationFilters) {
    internalValue.value.originLocationId = newVal.locationId;
    internalValue.value.originLocationName = newVal.locationName;
    internalValue.value.originLocationCode = newVal.locationCode;
    internalValue.value.originCity = newVal.city;
    internalValue.value.originState = newVal.state;
    internalValue.value.originPostalCode = newVal.postalCode;
    internalValue.value.originCountry = newVal.country;
  },
});
</script>
